import { jsxs as g, jsx as d } from "react/jsx-runtime";
import { GREY as o, alpha as r } from "../../utils/colors.js";
import { n as b } from "../../emotion-styled.browser.esm-Br5Hs_hj.js";
var C = /* @__PURE__ */ ((e) => (e.DA = "da", e.EN = "en", e.DE = "de", e.FR = "fr", e.NO = "no", e.FI = "fi", e.SV = "sv", e.IT = "it", e.ES = "es", e.CH = "ch", e.US = "us", e.CY = "cy", e.PT = "pt", e.ID = "id", e.AU = "au", e.BR = "br", e.AE = "ae", e.SA = "sa", e.QA = "qa", e.OM = "om", e.BH = "bh", e.KW = "kw", e))(C || {});
const A = [
  "da",
  "en",
  "no",
  "de"
  /* DE */
], u = [
  {
    languageCode: "da",
    code: "DK",
    label: "Danmark",
    language: "Dansk",
    phone: "+45",
    flag: "🇩🇰"
  },
  {
    languageCode: "fi",
    code: "FI",
    label: "Finland",
    language: "Finnish",
    phone: "+358",
    flag: "🇫🇮"
  },
  {
    languageCode: "sv",
    code: "SE",
    label: "Sverige",
    language: "Svenska",
    phone: "+46",
    flag: "🇸🇪"
  },
  {
    languageCode: "de",
    code: "DE",
    label: "Germany",
    language: "Deutsch",
    phone: "+49",
    flag: "🇩🇪"
  },
  {
    languageCode: "no",
    code: "NO",
    label: "Norge",
    language: "Norsk",
    phone: "+47",
    flag: "🇳🇴"
  },
  {
    languageCode: "it",
    code: "IT",
    label: "Italy",
    language: "Italian",
    phone: "+39",
    flag: "🇮🇹"
  },
  {
    languageCode: "es",
    code: "ES",
    label: "Spain",
    language: "Spanish",
    phone: "+34",
    flag: "🇪🇸"
  },
  {
    languageCode: "fr",
    code: "FR",
    label: "France",
    language: "French",
    phone: "+33",
    flag: "🇫🇷"
  },
  {
    languageCode: "en",
    code: "EN",
    label: "United Kingdom",
    language: "English",
    phone: "+44",
    flag: "🇬🇧"
  },
  {
    languageCode: "ch",
    code: "CH",
    label: "Switzerland",
    language: "French",
    phone: "+41",
    flag: "🇨🇭"
  },
  {
    languageCode: "us",
    code: "US",
    label: "United States",
    language: "English",
    phone: "+1",
    flag: "🇺🇸"
  },
  {
    languageCode: "cy",
    code: "CY",
    label: "Cyprus",
    language: "Greek",
    phone: "+357",
    flag: "🇨🇾"
  },
  {
    languageCode: "pt",
    code: "PT",
    label: "Portugal",
    language: "Portugese",
    phone: "+351",
    flag: "🇵🇹"
  },
  {
    languageCode: "id",
    code: "ID",
    label: "Indonesia",
    language: "Indonesian",
    phone: "+62",
    flag: "🇮🇩"
  },
  {
    languageCode: "au",
    code: "AU",
    label: "Australia",
    language: "English",
    phone: "+61",
    flag: "🇦🇺"
  },
  {
    languageCode: "br",
    code: "BR",
    label: "Brazil",
    language: "Portuguese",
    phone: "+55",
    flag: "🇧🇷"
  },
  // UAE
  {
    languageCode: "ae",
    code: "AE",
    label: "United Arab Emirates",
    phone: "+971",
    flag: "🇦🇪"
  },
  // Saudi Arabia
  {
    languageCode: "sa",
    code: "SA",
    label: "Saudi Arabia",
    phone: "+966",
    flag: "🇸🇦"
  },
  // Qatar
  {
    languageCode: "qa",
    code: "QA",
    label: "Qatar",
    phone: "+974",
    flag: "🇶🇦"
  },
  // Oman
  {
    languageCode: "om",
    code: "OM",
    label: "Oman",
    phone: "+968",
    flag: "🇴🇲"
  },
  // Kuwait
  {
    languageCode: "kw",
    code: "KW",
    label: "Kuwait",
    phone: "+965",
    flag: "🇰🇼"
  },
  // Bahrain
  {
    languageCode: "bh",
    code: "BH",
    label: "Bahrain",
    phone: "+973",
    flag: "🇧🇭"
  }
].sort((e, n) => e.phone.localeCompare(n.phone)), k = ({
  customColor: e,
  onCountryChange: n,
  onChange: p,
  placeholder: i,
  defaultCountryCode: c
}) => {
  const t = (a) => {
    const s = a.target.value, l = u.find((f) => f.phone === s);
    l && n(l.phone);
  }, h = (a) => {
    p(a.target.value);
  };
  return /* @__PURE__ */ g(m, { customColor: e, children: [
    /* @__PURE__ */ d(
      "select",
      {
        defaultValue: c,
        onChange: t,
        style: {
          border: "none",
          background: "transparent",
          padding: "12px",
          fontSize: "16px",
          appearance: "none",
          WebkitAppearance: "none",
          MozAppearance: "none",
          outline: "none"
        },
        children: u.map((a) => /* @__PURE__ */ g("option", { value: a.phone, children: [
          a.flag,
          " ",
          a.phone
        ] }, a.code))
      }
    ),
    /* @__PURE__ */ d(
      "input",
      {
        type: "tel",
        placeholder: i || "Enter phone number",
        onInput: h,
        style: {
          transition: "border-color 0.2s",
          outline: "none",
          border: "none",
          borderLeft: `2px solid ${o[300]}`,
          background: "transparent",
          flex: 1,
          padding: "12px",
          fontSize: "16px",
          minWidth: 200
        }
      }
    )
  ] });
}, m = b.div`
  display: flex;
  align-items: center;
  border: 2px solid ${o[300]};
  border-radius: 8px;
  overflow: hidden;
  max-width: 400px;
  transition: border-color 0.2s;
  background-color: #fff;
  &:hover {
    border-color: ${o[400]};
    input {
      border-left-color: ${o[400]} !important;
    }
  }
  &:focus-within {
    border-color: ${(e) => r(e.customColor || "#333", 0.5)};
    input {
      border-left-color: ${(e) => r(e.customColor || "#333", 0.5)} !important;
    }
  }
`;
export {
  C as Intl,
  u as countries,
  k as default,
  A as supportedFormLanguages
};
